export default function doLimit(fn, limit) {
    return function (iterable, iteratee, callback) {
        return fn(iterable, limit, iteratee, callback);
    };
}



// WEBPACK FOOTER //
// ../../../../~/async-es/internal/doLimit.js